(() => {
  const dialog = document.getElementById('ef-image-enlargement');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  const caption = dialog.querySelector('p');
  let opener;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-image-enlarge]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    const source = trigger.dataset.imageEnlarge;
    if (!source) return;
    opener = trigger;
    image.src = source;
    image.alt = trigger.dataset.imageCaption || trigger.querySelector('img')?.alt || 'Product image';
    caption.textContent = image.alt;
    dialog.showModal();
  });
  dialog.querySelector('button').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { image.removeAttribute('src'); if(opener?.isConnected) opener.focus(); });
})();
